<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center">
        <v-img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWOGRiUjhCghJq_BMnKuV5joUkLMeUFijKJg&s" alt="404 Not Found" width="300" class="mx-auto" />
        <h1>Página no encontrada</h1>
        <p>Lo sentimos, la página que estás buscando no existe.</p>
        <v-btn color="primary" @click="goHome">Volver al inicio</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFoundView",
  methods: {
    goHome() {
      this.$router.push({ name: "Home" });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}
</style>